import {
  Box,
  ContentBlock,
  Heading,
  IconMail,
  IconPeople,
  IconStar,
  Stack,
  Text,
  Tiles,
} from 'braid-design-system';

import * as styles from './BrandBanner.css';

const stats: Array<{
  Icon: typeof IconPeople;
  value: string;
  label: string;
}> = [
  {
    Icon: IconPeople,
    value: '170,000+',
    label: 'potential buyers visit every month',
  },
  {
    Icon: IconStar,
    value: 'Nearly 2x',
    label: 'the buyer visits compared to closest competitor',
  },
  {
    Icon: IconMail,
    value: '50,000+',
    label: 'buyers matched to businesses every day',
  },
];

export const BrandBanner = () => (
  <Box
    background="brandAccent"
    borderRadius="xlarge"
    paddingY="large"
    paddingX={{ mobile: 'gutter', tablet: 'large' }}
    data={{ testid: 'packages-brand-banner' }}
  >
    <Stack space="large" align="center">
      <Heading level="2" align="center">
        Reach <span className={styles.highlight}>more buyers</span>. Move
        forward confidently.
      </Heading>

      <ContentBlock width="medium">
        <Tiles columns={{ mobile: 1, tablet: 3 }} space="medium">
          {stats.map((stat) => (
            <Stack key={stat.value} space="medium" align="center">
              <Box className={styles.icon}>
                <stat.Icon size="fill" />
              </Box>
              <Stack space="small" align="center">
                <Text weight="strong" align="center">
                  {stat.value}
                </Text>
                <Text size="xsmall" align="center">
                  {stat.label}
                </Text>
              </Stack>
            </Stack>
          ))}
        </Tiles>
      </ContentBlock>

      <Text size="xsmall" tone="secondary" align="center">
        Based on average monthly data, last 12 months.
      </Text>
    </Stack>
  </Box>
);
